import * as React from "react";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux";
import { Product } from "../../../gobalType";
import { BASE_URL, HttpMethod } from "../../../services/api.constant";
import "./style.scss";
import Pages from "../..";
import { callHttpClientMethod } from "../../../services/callHttpClient";
import { slider } from "../../../services/apiList";
import PotsSlider, { SliderItem } from "./components/PotsSlider";
import PotsProductGrid from "./components/PotsProductGrid";
import { PotsPageEmpty, PotsPageLoading } from "./components/PotsPageState";

const PotsPage = () => {
  const { product_lists, loadingPf } = useSelector(
    (state: RootState) => state.products
  );
  const [potSliders, setPotSliders] = useState<SliderItem[]>([]);
  const [loadingSlider, setLoadingSlider] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPotSliders = async () => {
      try {
        const response = await callHttpClientMethod(
          BASE_URL + slider(5),
          HttpMethod.Get,
          {},
          {}
        );
        setPotSliders(response?.data || []);
      } catch (error) {
        setPotSliders([]);
      } finally {
        setLoadingSlider(false);
      }
    };
    fetchPotSliders();
  }, []);

  const handlePotDetails = (product: Product) => {
    navigate(`/product-details/${product.id}`, {
      state: {
        product_id: product?.product_sizes?.[0]?.product_id,
        size_id: product?.product_sizes?.[0]?.id,
      },
    });
  };
  if (loadingPf) {
    return <PotsPageLoading />;
  }
  return (
    <Pages>
      <Box
        sx={{
          /* 8 trong sx = 8×theme.spacing → ~64px, thừa khoảng trống dưới header fixed */
          marginTop: { xs: 0, sm: 2 },
          backgroundColor: "transparent",
          paddingBottom: 5,
          width: { xs: "100%", sm: "650px", md: "800px", lg: "981px" },
          maxWidth: "100%",
          boxSizing: "border-box",
        }}
      >
        {loadingSlider ? (
          <PotsPageLoading className="pots-slider-loading" />
        ) : potSliders.length > 0 ? (
          <PotsSlider potSliders={potSliders} />
        ) : null}


        {product_lists?.length > 0 ? (
          <Box
            sx={{
              px: { xs: 2, sm: 0 },
              width: "100%",
              maxWidth: "100%",
              boxSizing: "border-box",
            }}
          >
            <PotsProductGrid
              products={product_lists}
              onProductClick={handlePotDetails}
            />
          </Box>
        ) : (
          <PotsPageEmpty />
        )}
      </Box>
    </Pages>
  );
};

export default React.memo(PotsPage);
